import { IconButton, makeStyles, SvgIcon } from '@material-ui/core';
import React, { FC } from 'react';
import { ReactComponent as AlertIcon } from 'src/assets/d.icons/alert.svg';
import { ReactComponent as CloseIcon } from 'src/assets/d.icons/close.svg';
import { ReactComponent as ConfirmIcon } from 'src/assets/d.icons/confirm.svg';
import { DialogType } from 'src/redux/types/redux.types';
// import I18n from 'components/I18n';

interface Props {
  children: React.ReactNode;
  type: DialogType;
  onClose: React.MouseEventHandler<any> | undefined;
  hideX?: Boolean;
}

const useStyles = makeStyles(theme => ({
  root: {
    background: ({ empty }: { empty: boolean }) =>
      empty ? 'transparent' : theme.palette.primary.main,
    height: 60,
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 12px 0 15px',
    fontSize: '1.3rem',
    textAlign: 'start',
  },
  content: {
    flex: 1,
    fontWeight: 600,
  },
  closeButton: {
    padding: 0,
    fontSize: '1em',
    top: 0,
  },
  closeIcon: {
    flex: '0 0 auto',
    width: '1em',
    height: '1em',
    color: '#656565',
  },
  alertIcon: {
    width: '22px',
    margin: '6px 10px 0 0 ',
    height: '22px',
  },
}));

const headerIcons = {
  alert: AlertIcon,
  confirm: ConfirmIcon,
};

const DialogHeader: FC<Props> = ({ children, onClose, type, hideX }) => {
  const classes = useStyles({ empty: true });
  const headerIcon = headerIcons[type];
  //todo idan refactor all modals

  return (
    <header className={classes.root} dir="auto">
      {headerIcon && <SvgIcon component={headerIcons[type]} className={classes.alertIcon} />}
      <span className={classes.content}>
        {/* <I18n>{children}</I18n> */}
        {children}
      </span>
      {!hideX ? (
        <IconButton type="button" className={classes.closeButton} onClick={onClose}>
          <SvgIcon component={CloseIcon} className={classes.closeIcon} />
        </IconButton>
      ) : null}
    </header>
  );
};

export default DialogHeader;
